import React from 'react';
import { StylableProp } from '../../utils/stylable-prop';
interface TeamVideoProps {
  videoSrcURL: string;
  videoTitle: string;
  className: string;
}
const Video = (props: StylableProp<TeamVideoProps>) => (
  <div id="video">
    <div className={props.className}>
      <iframe
        src={props.videoSrcURL}
        title={'YouTube video player'}
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        frameBorder="0"
        className="h-full w-full"
        //   webkitallowfullscreen="true"
        //   mozallowfullscreen="true"
        allowFullScreen
      />
    </div>
  </div>
);
export default Video;
